import { render, staticRenderFns } from "./pageTable.vue?vue&type=template&id=30fa7853&scoped=true&"
import script from "./pageTable.vue?vue&type=script&lang=js&"
export * from "./pageTable.vue?vue&type=script&lang=js&"
import style0 from "./pageTable.vue?vue&type=style&index=0&id=30fa7853&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fa7853",
  null
  
)

export default component.exports